import React from "react";
import ContactUsForm from "../components/ContactPage/ContactUsForm";
import { IoIosChatboxes } from "react-icons/io";
import { FaPhoneAlt } from "react-icons/fa";
import { FaGlobeAmericas } from "react-icons/fa";
import ReviewSlider from "../components/common/ReviewSlider";

function ContactUs(props) {
  return (
    <div>
      <div className="grid grid-cols-2 max-[450px]:grid-cols-1 mt-20 place-items-center mb-10 relative">
        {/* left */}
        <div className="w-[80%] -translate-y-[80%] max-[450px]:translate-y-0 max-[450px]:hidden">
          <div className="py-5 px-10 bg-richblack-700 flex flex-col justify-center items-center rounded-lg w-[70%]">
            <div className="">
              <div className="flex gap-x-5">
                <div className="text-richblack-25 mt-1 text-xl">
                  {/* chat icon */}
                  <IoIosChatboxes />
                </div>
                <div className="flex flex-col">
                  <div className="text-richblack-25 text-2xl">Chat on us</div>
                  <div className="text-richblack-100">
                    Our friendly team is here to help. @mail address
                  </div>
                </div>
              </div>
            </div>
            <div className="">
              <div className="flex mt-2 gap-x-5">
                <div className="text-richblack-25 mt-1 text-xl">
                  {/* chat icon */}
                  <FaGlobeAmericas />
                </div>
                <div className="flex flex-col">
                  <div className="text-richblack-25 text-2xl">Visit us</div>
                  <div className="text-richblack-100">
                  Come and say hello at our office HQ. Here is the location/ address
                  </div>
                </div>
              </div>
            </div>
            <div className="">
              <div className="flex mt-2 gap-x-5">
                <div className="text-richblack-25 mt-1 text-xl">
                  {/* phone icon */}
                  <FaPhoneAlt />
                </div>
                <div className="flex flex-col">
                  <div className="text-richblack-25 text-2xl">Call us</div>
                  <div className="text-richblack-100">
                  Mon - Fri From 8am to 5pm +123 456 7890
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* right */}
        <div className="w-[80%] border border-richblack-700 p-5 rounded-lg">
          <h1 className="text-3xl text-richblack-25 font-semibold">
            Got a Idea? We’ve got the skills. Let’s team up
          </h1>
          <p className="text-richblack-50 mt-2">
            Tall us more about yourself and what you’re got in mind.
          </p>
          <div className="mt-10 max-[450px]:w-[100%]">
            <ContactUsForm />
          </div>
        </div>
      </div>
      <ReviewSlider/>
    </div>
  );
}

export default ContactUs;
